export const invoiceSymbolRecordStatus = [
  { key: "O", badgeColor: "badge-soft-success" },
  { key: "C", badgeColor: "badge-soft-danger" },
];

export const invoiceSymbolRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const invoiceSymbolModeList = {
  CREATE_INVOICE_SYMBOL_DETAIL: "CREATE_INVOICE_SYMBOL_DETAIL",
  VIEW_INVOICE_SYMBOL_DETAIL: "VIEW_INVOICE_SYMBOL_DETAIL",
  EDIT_INVOICE_SYMBOL_DETAIL: "EDIT_INVOICE_SYMBOL_DETAIL",
};

export const KyHieuMauHoaDonMode = {
  VAT_INVOICE: "1",
  SALE_INVOICE: "2",
  TICKETS_INVOICE: "5",
  DELIVERY_BILL: "6",
};
export const KyHieuMauHoaDonList = [{ value: "1", label: "" }];
